/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PasswordResetConfirmMutationRequest,
  PasswordResetConfirmMutationResponse,
} from '../types/PasswordResetConfirm'

function getPasswordResetConfirmUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/password-reset-confirm/` as const,
  }
  return res
}

/**
 * @description Wrapper around dj-rest-auth PasswordResetConfirmView for debugging
 * @summary Confirm a password reset
 * {@link /api/v1/password-reset-confirm/}
 */
export async function passwordResetConfirm(
  data: PasswordResetConfirmMutationRequest,
  config: Partial<RequestConfig<PasswordResetConfirmMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    PasswordResetConfirmMutationResponse,
    ResponseErrorConfig<Error>,
    PasswordResetConfirmMutationRequest
  >({
    method: 'POST',
    url: getPasswordResetConfirmUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
